module.exports = __webpack_public_path__ + "img/Nav Bars.3d6365d6.png";